import { useState } from 'react';
import cls from './Onboarding.module.scss';
import beforeButtonImg from '../../shared/assets/images/before-button.svg';
import nextButtonImg from '../../shared/assets/images/next-button.svg';
import { setPage } from '../../shared/redux/page/slice';
import { Pages } from '../../shared/redux/page/types';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../shared/redux/store';
import { sounds } from '../../shared/ui/Sound/assets';
import shipOne from '../../shared/assets/images/ship-1.svg';
import shipTwo from '../../shared/assets/images/ship-2.svg';
import shipThree from '../../shared/assets/images/ship-3.svg';
import bearSrc from '../../shared/assets/images/bear.svg';
import iceSrc from '../../shared/assets/images/ice.svg';
import icebergSrc from '../../shared/assets/images/iceberg.svg';
import leftSrc from '../../shared/assets/images/left.svg';
import rightSrc from '../../shared/assets/images/right.svg';
import traceSrc from '../../shared/assets/images/trace.svg';

export const Onboarding = () => {
  const dispatch = useDispatch();
  const [onbPage, setOnbPage] = useState(1);
  const isSound = useSelector((state: RootState) => state.page.isSound);
  const getContainerCls = () => {
    if (onbPage === 1) {
      return cls.Onb1;
    } else {
      return cls.OnbElse;
    }
  };
  return (
    <div className={`${getContainerCls()} ${cls.Onboarding} page-container`}>
      {onbPage === 1 && (
        <div className="text-container" style={{ top: '35%' }}>
          <p className="text-bg-p">
            Привет, мореход! Ты назначен капитаном ледоколов. И теперь тебе предстоит проложить путь
            через льды Арктики!
          </p>
          <p>
            Привет, мореход! Ты назначен капитаном ледоколов. И теперь тебе предстоит проложить путь
            через льды Арктики!
          </p>
        </div>
      )}
      {onbPage === 2 && (
        <>
          <div className="text-container" style={{ top: '15%' }}>
            <p className="text-bg-p">Впереди три уровня сложности и три ледокола.</p>
            <p>Впереди три уровня сложности и три ледокола.</p>
          </div>
          <div className={cls.ships}>
            <img alt="ship" src={shipOne} />
            <img alt="ship" src={shipTwo} />
            <img alt="ship" src={shipThree} />
          </div>
        </>
      )}
      {onbPage === 3 && (
        <>
          <div className="text-container" style={{ top: '15%' }}>
            <p className="text-bg-p">
              Будь осторожен: <br /> управляй судном и обходи препятствия с помощью стрелочек.
            </p>
            <p>
              Будь осторожен: <br /> управляй судном и обходи препятствия с помощью стрелочек.
            </p>
          </div>
          <div className={cls.obstacles}>
            <img alt="Bear" src={bearSrc} className={cls.bearImg} />
            <img alt="Ice" src={iceSrc} className={cls.iceImg} />
            <img alt="Iceberg" src={icebergSrc} className={cls.icebergImg} />
          </div>
          <div className={cls.buttonsExample}>
            <img alt="Left" src={leftSrc} />
            <img alt="Right" src={rightSrc} />
          </div>
        </>
      )}
      {onbPage === 4 && (
        <>
          <div className="text-container" style={{ top: '15%' }}>
            <p className="text-bg-p" style={{ padding: '0 11px' }}>
              Помни: у каждого ледокола разные возможности.  Внимательно читай правила перед новым
              уровнем.
            </p>
            <p style={{ padding: '0 11px' }}>
              Помни: у каждого ледокола разные возможности.  Внимательно читай правила перед новым
              уровнем.
            </p>
          </div>
          <img alt="Trace" src={traceSrc} className={cls.traceImg} />
          <img alt="Ship" src={shipTwo} className={cls.shipImg} />
          <button
            className={cls.startButton}
            onClick={() => {
              if (isSound) {
                sounds.btn.play();
              }
              dispatch(setPage(Pages.GAME));
            }}></button>
        </>
      )}
      {onbPage > 1 && (
        <img
          alt="Before button"
          src={beforeButtonImg}
          className={cls.buttonBefore}
          onClick={() => {
            if (isSound) {
              sounds.btn.play();
            }
            setOnbPage((act) => act - 1);
          }}
        />
      )}
      {onbPage < 4 && (
        <img
          alt="Next button"
          src={nextButtonImg}
          className={cls.buttonNext}
          onClick={() => {
            if (isSound) {
              sounds.btn.play();
            }
            setOnbPage((act) => act + 1);
          }}
        />
      )}
    </div>
  );
};
